import { generateRandomNumber } from "../numbers/utils";

/**
 * Deliver a Random element from an array
 *
 * @param arrayOfObjects - Array of elements
 * @returns - Return a random element from an array
 */
export const getRandomElementFromArray = <T>(arrayOfObjects: T[]): T | null => {
  if (arrayOfObjects.length <= 0) {
    return null;
  }
  const index = generateRandomNumber(0, arrayOfObjects.length - 1);
  return arrayOfObjects[index] as T;
};
